import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_ATTRIBUTE = "listAttribute";
export const GET_DETAIL_ATTRIBUTE = "detailAttribute";
export const SAVE_ATTRIBUTE = "saveAttribute";
export const UPDATE_ATTRIBUTE = "updateAttribute";
export const DELETE_ATTRIBUTE = "deleteAttribute";
export const UPLOAD_ATTRIBUTE_IMAGE = "/admin/upload";


export const SET_LIST_ATTRIBUTE = "setListAttribute";
export const SET_DETAIL_ATTRIBUTE = "setDetailAttribute";


const state = {
    attributes: [],
    attribute: {},
};

const getters = {
    attributes(state) {
        return state.attributes;
    },
    attributeDetail(state) {
        return state.attribute;
    },
};

const actions = {
    [GET_LIST_ATTRIBUTE](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ATTRIBUTE).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_ATTRIBUTE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_ATTRIBUTE](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_ATTRIBUTE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_ATTRIBUTE, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_ATTRIBUTE_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(UPLOAD_ATTRIBUTE_IMAGE, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [SAVE_ATTRIBUTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_ATTRIBUTE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {

                    reject(err);
                });
        });
    },
    [UPDATE_ATTRIBUTE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_ATTRIBUTE}`,payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_ATTRIBUTE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_ATTRIBUTE}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_ATTRIBUTE](state, data) {
        state.attributes = data.data;
    },
    [SET_DETAIL_ATTRIBUTE](state, data) {
        state.attribute = data.data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
